export const getOtpError = (state) => state.common.auth.error

export const getHeaderTokenType = (state) => state.headerTokenType;